if (!customElements.get('vertical-slider')) {
  class VerticalSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (
        !this.querySelector('[data-slider]') ||
        this.hasAttribute('disabled')
      ) {
        return;
      }

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 31,
        direction: 'vertical',
        centerInsufficientSlides: true,
        loop: true,
        centeredSlides: true,
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
      };

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }
  customElements.define('vertical-slider', VerticalSlider);
}
